<template>
  <div>
    <div v-loading="loading">
      <div>
        <!-- issue不属于当前用户 -->
        <div v-if="!isCurrentUser && status === -10">
          <el-tag type="info"
                  size="medium">admin已处理这个issue
          </el-tag>
        </div>
        <!-- issue属于当前用户 -->
        <div
          v-permission="226"
          v-else>
          <div v-if="detail.id">
            <!-- issue不为 处理中、下次处理 状态 -->
            <el-button type="success"
                       size="mini"
                       v-if="!isCurrentUser || [30].includes(status)"
                       @click="getIssue"
                       :loading="getIssueLoading">领取
            </el-button>
            <el-button type="success"
                       size="mini"
                       v-if="isCurrentUser && [10,20].includes(status)">已领取
            </el-button>
            <!-- issue为 处理中、下次处理 状态 -->
            <el-select
              v-show="isCurrentUser && [10,20].includes(status)"
              style="width: 100%;margin-top: 15px;"
              :value="statusValue"
              @change="onChangeState"
              placeholder="请选择处理选项"
              size="mini">
              <el-option
                v-for="(item, index) in stateOptions"
                :key="item.label"
                :label="item.label"
                :value="index">
              </el-option>
            </el-select>
            <!-- issue为 已处理、用户已读 状态 -->
            <el-tag v-show="[-10, -20].includes(status)"
                    type="info"
                    size="medium">您已处理这个issue
            </el-tag>
          </div>
        </div>
      </div>
      <!-- issue为 已处理、用户已读 状态 -->
      <div v-permission="225"
           v-show="[-10,-20].includes(status)"
           style="margin-top: 15px;">
        <el-button type="info"
                   size="mini"
                   @click="open()"
                   v-loading="openLoading">客服再次联系
        </el-button>
      </div>
      <el-input
        style="margin-top: 15px;"
        type="textarea"
        autosize
        placeholder="请输入评论内容"
        v-model="textarea"
        size="mini">
      </el-input>
      <div style="margin-top: 15px;">
        <el-button type="primary"
                   size="mini"
                   :disabled="!textarea"
                   @click="addComment()"
                   :loading="addCommentLoading">
          添加评论
        </el-button>
      </div>
    </div>
    <div class="issue-list"
         style="margin-top: 15px;"
         v-for="{operationtime, operator, content} in logs">
      <p class="issue-date">{{operationtime}}</p>
      <p>
        <b>{{operator}}: </b>
        <span style="display: inline-block" v-html="content"></span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {
    orderId: [Number, String],
    issueId: [Number, String],
  },
  data () {
    return {
      textarea: '',
      stateOptions: [
        {
          label: '已经沟通，愿意修改',
          value: 'finish', // -10
        },
        {
          label: '已经沟通，放弃修改',
          value: 'giveup', // -10 关闭工单
        },
        {
          label: '号码异常，告知推广',
          value: 'finish', // -10
        },
        {
          label: '无法联系，下次处理',
          value: 'suspend', // 10
        },
      ],
      statusValue: null,
      table: [],
      getIssueLoading: false,
      addCommentLoading: false,
      openLoading: false,
      loading: false,
      detail: {},
      logs: [],
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
    isCurrentUser () {
      return this.detail.master === this.user.id
    },
    status () {
      return Number(this.detail.status)
    },
  },
  watch: {
    status (status) {
      if (status && status === 10 && this.isCurrentUser) {
        this.statusValue = 3
      }
    },
  },
  beforeCreate () {},
  created () {
    if (this.issueId > 0) {
      this.loading = true
      this.loadIssueList(this.issueId).then(() => {
        this.loading = false
      })
    }
  },
  mounted () {},
  methods: {
    loadIssueList (id) {
      return request.all.alert([
        request('getIssueDetail', {id}),
        request('getIssueLogs', {id}),
      ]).then(([{
        data: detailData,
      }, {
        data: logData,
      }]) => {
        this.detail = detailData
        this.logs = logData
      })
    },
    open () {
      this.openLoading = true
      request.alert('updateIssueOpen', {id: this.detail.id, logString: '客服再次联系'}).then(() => {
        this.changeState(30)
        this.$message.success('您打开了ISSUE')
      }).finally(() => {
        this.openLoading = false
      })
    },
    create () {
      return request.alert('createIssue', {order_id: this.orderId, logString: this.textarea})
    },
    addLog (content) {
      this.logs = [
        {
          operationtime: filter.formatDate(), operator: this.user.name, content,
        },
        ...this.logs,
      ]
      this.textarea = ''
    },
    addComment () {
      this.addCommentLoading = true
      // 已存在issue
      if (this.detail.id) {
        request.alert('addIssueComment', {id: this.detail.id, logString: this.textarea}).then(() => {
          this.addLog(this.textarea)
          this.$message.success('添加了一条ISSUE评论')
        }).finally(() => {
          this.addCommentLoading = false
        })
      } else {
        // 创建新issue
        this.create().then(({data}) => {
          // 重新获得issue详情
          request.alert('getIssueDetail', {id: data.id}).then(({data}) => {
            this.detail = data
            this.addLog(this.textarea)
          })
        }).finally(() => {
          this.addCommentLoading = false
        })
      }
    },
    getIssue () {
      this.getIssueLoading = true
      request.alert('updateIssueUser', {id: this.detail.id, logString: '领取ISSUE'}).then(() => {
        this.changeState(20, this.user.id)
        this.$message.success('已领取ISSUE')
      }).finally(() => {
        this.getIssueLoading = false
      })
    },
    changeState (status, master) {
      if (this.detail.status !== status) {
        let detail = {
          ...this.detail,
          status: status,
        }
        if (master) {
          detail.master = master
        }
        this.detail = detail
      }
    },
    onChangeState (index) {
      let text = this.stateOptions[index].label
      switch (this.stateOptions[index].value) {
        case 'finish':
          this.loading = true
          request.alert('updateIssueFinish', {id: this.detail.id, logString: text}).then(() => {
            this.addLog(text)
            this.changeState(-10)
            this.statusValue = index
            this.loading = false
          })
          break
        case 'giveup':
          this.$confirm('放弃修改后, 系统将收回工单，是否确认?', '提示', {
            type: 'warning',
          }).then(() => {
            this.loading = true
            request.alert('updateIssueFinishAndOrderNotPassed', {
              id: this.detail.id,
              order_id: this.orderId,
              logString: text,
            }).then(() => {
              this.addLog(text)
              this.changeState(-10)
              this.statusValue = index
              this.loading = false
            })
          })
          break
        case 'suspend':
          this.loading = true
          request.alert('updateIssueWait', {id: this.detail.id, logString: text}).then(() => {
            this.addLog(text)
            this.changeState(10)
            this.statusValue = index
            this.loading = false
          })
          break
      }
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.issue-list {
  background-color: #f9fafc;
  padding: 10px;

  p {
    margin: 0px;
  }

  .issue-date {
    font-size: 10px;
    color: #909399;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/issue/components/IssueLighter/index.vue